<template>
  <div class="my-share-code-page">
    <ShareCodeContent v-if="isRegistered" />
    <RegisterSharer v-else />
  </div>
</template>

<script>
import ShareCodeContent from './ShareCodeContent.vue';
import RegisterSharer from './RegisterSharer.vue';
import { judgeAgentEmployee } from '../common/api.js';

export default {
  name: 'MyShareCode',
  components: {
    ShareCodeContent,
    RegisterSharer
  },
  data() {
    return {
      isRegistered: false
    };
  },
  mounted() {
    if (localStorage.getItem('_isRegistered') === 'false' || !localStorage.getItem('_isRegistered')) {
      this.isRegistered = false;
      this.toJudgeAgentEmployee();
    } else {
      this.isRegistered = true;
    }
  },
  methods: {
    // 判断是否注册成功
    toJudgeAgentEmployee() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      const param = {
        agencyCode: localStorage.getItem('_encryptAgencyCode') || '',
        phone: localStorage.getItem('_phone') || ''
      };
      judgeAgentEmployee(param).then((res) => {
        this.isRegistered = res || false;
        localStorage.setItem('_isRegistered', this.isRegistered);
        this.$toast.clear();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-share-code-page {
  min-height: 100vh;
  background: #f7f7f7;
  box-sizing: border-box;
}
</style>
